import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const MAIN_LINKS = [
  { href: "/#zdrowie", label: "Diagnostyka" },
  { href: "/#match", label: "Secure Match" },
  { href: "/#natal", label: "Secure Natal" },
  { href: "/#ivf", label: "IVF" },
];

const MOBILE_EXTRA = [
  { href: "/#proces", label: "Jak to działa" },
  { href: "/#kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 inset-x-0 z-50 pointer-events-none"
    >
      <div className="nuuma-container pointer-events-auto">
        <div
          className={`bg-white rounded-b-[28px] transition-shadow duration-300 ${
            scrolled
              ? "shadow-[0_10px_30px_rgba(41,33,104,0.15)]"
              : "shadow-[0_6px_20px_rgba(41,33,104,0.08)]"
          }`}
        >
          {/* Main row (extra top padding preserves the original two-row height) */}
          <div className="flex items-center justify-between px-5 sm:px-8 py-4 lg:pt-10 lg:pb-6">
            <a
              href="/#top"
              data-testid="nav-logo"
              className="flex items-center min-w-0"
              aria-label="Nuuma Genetics"
            >
              <img
                src="/assets/nuuma-logo.svg"
                alt="Nuuma Genetics"
                width="315"
                height="45"
                className="w-[200px] sm:w-[315px] h-auto object-contain"
              />
            </a>

            <nav
              data-testid="nav-desktop-links"
              className="hidden lg:flex items-center gap-9"
            >
              {MAIN_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`nav-link-${l.href.replace("#", "")}`}
                  className="text-[0.95rem] font-medium text-nuuma-primary hover:text-nuuma-secondary transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </nav>

            <div className="hidden lg:flex items-center">
              <a
                href="/#kontakt"
                data-testid="nav-cta-button"
                className="btn-pill btn-primary-nuuma text-sm"
              >
                Umów konsultację
                <ArrowRight className="h-4 w-4" />
              </a>
            </div>

            {/* Mobile toggler */}
            <button
              data-testid="nav-mobile-toggle"
              className="lg:hidden p-2 rounded-md text-nuuma-primary hover:bg-nuuma-grey100"
              onClick={() => setOpen((o) => !o)}
              aria-label="Menu"
              aria-expanded={open}
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {/* Mobile menu */}
          {open && (
            <div
              data-testid="nav-mobile-menu"
              className="lg:hidden border-t border-nuuma-grey200 px-5 py-3"
            >
              {[...MAIN_LINKS, ...MOBILE_EXTRA].map((l, i) => (
                <a
                  key={`${l.label}-${i}`}
                  href={l.href}
                  data-testid={`nav-mobile-link-${i}`}
                  onClick={() => setOpen(false)}
                  className="block py-3 px-1 text-[0.95rem] font-medium text-nuuma-grey900 hover:text-nuuma-primary border-b border-nuuma-grey100 last:border-0"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="/#kontakt"
                data-testid="nav-mobile-cta"
                onClick={() => setOpen(false)}
                className="btn-pill btn-primary-nuuma mt-4 w-full justify-center"
              >
                Umów konsultację
                <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
